import { render, staticRenderFns } from "./businessTemplate.vue?vue&type=template&id=648e9cce&scoped=true&"
import script from "./businessTemplate.vue?vue&type=script&lang=ts&"
export * from "./businessTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e9cce",
  null
  
)

export default component.exports